
import { Component, Vue } from 'vue-property-decorator'
import NumberedCardSection from '@/components/NumberedCardSection.vue'
import InfoBlock from './components/InfoBlock.vue'

interface InfoSectionItem {
  eyebrow: string;
  title: string;
  subtitle: string;
  bullets: readonly string[];
  image?: string | null;
  alt: string;
  backgroundColor: string;
}

interface NumberedCardItem {
  title: string;
  description: string;
  image?: string | null;
  alt?: string;
}

const INFO_SECTIONS: readonly InfoSectionItem[] = [
  {
    eyebrow: 'Multi-Channel Sharing',
    title: '多渠道社交分享觸達每個潛在客戶',
    subtitle: '支援三大主流分享渠道，讓食客用最慣用嘅方式，將你間餐廳推薦俾身邊嘅朋友。',
    bullets: [
      'WhatsApp 一鍵發送，快速轉發俾好友同群組',
      '微信小程序內置分享，觸達大陸同港澳用戶',
      '複製邀請連結，靈活分享去任何平台',
      '分享精美邀請卡片，提高邀請成功率'
    ],
    image: 'https://spics.inctrip.com/78e984c6b93b75fc4ef3e391a16fd1a6.png',
    alt: '餐廳透過 WhatsApp、微信及邀請連結進行多渠道社交分享',
    backgroundColor: '#fff7ee'
  },
  {
    eyebrow: 'Dual Reward System',
    title: '雙向獎勵機制分享有獎 · 邀請有禮',
    subtitle: '邀請朋友落單享優惠，自己賺到額外獎勵，分享裂變動力更持久。一部機全自動搞掂',
    bullets: [
      '分享人獎勵：好友完成首單，自動收到券包獎勵',
      '受邀人獎勵：新客戶註冊即享新人專屬券包',
      '支援首單獎勵 / 每單獎勵，靈活調節激勵力度',
      '獎勵上限可控，餐廳推廣預算話晒事'
    ],
    image: 'https://spics.inctrip.com/2d6cea04e31e6d4cb6b6132864b6876a.png',
    alt: '餐廳社交分享人與受邀人雙向獎勵機制',
    backgroundColor: '#fffaec'
  },
  {
    eyebrow: 'Backend Config',
    title: '後台一鍵設定品牌級活動管理',
    subtitle: '品牌層面統一設定社交分享活動，旗下多間分店同步生效，營運效率大大提升。',
    bullets: [
      '活動 Banner 同落地頁風格自訂，突顯品牌形象',
      '分享期、獎勵期、活動期分開設定',
      '分享者同受邀者獎勵獨立配置，券包靈活掛接'
    ],
    image: 'https://spics.inctrip.com/530b96c6f41e3f12f0f0e3d09312e3f6.png',
    alt: '品牌後台統一設定餐廳社交分享活動',
    backgroundColor: '#f0f9ff'
  },
  {
    eyebrow: 'Landing Page',
    title: '精美活動落地頁轉換率節節上升',
    subtitle: '專業設計嘅活動落地頁，清楚展示獎勵規則同進度，令用戶一眼睇明、即刻行動。',
    bullets: [
      '活動 Banner 視覺夠吸睛，快速捉住注意力',
      '獎勵規則清晰呈現，進度實時可查',
      '「立即分享」按鈕夠搶眼，一鍵喚起分享',
      '靈活設定活動曝光，首頁 Banner、彈窗、輪播圖多入口引流'
    ],
    image: 'https://spics.inctrip.com/7b44fc7093064f0a3f61018e88b699c8.png',
    alt: '顯示獎勵規則與分享進度的餐廳活動落地頁',
    backgroundColor: 'rgba(236,247,228,0.50)'
  },
  {
    eyebrow: 'Dashboard',
    title: '數據儀表板推廣效果一目了然',
    subtitle: '全方位數據追蹤同分析，幫助餐廳老闆實時掌握活動成效，優化推廣策略。旗下多間分店同步生效，營運效率大大提升。',
    bullets: [
      '分享率：活動頁面瀏覽 → 分享轉換',
      '邀請轉換率：連結點擊 → 新客戶註冊',
      '首單率：新客戶註冊 → 完成首單',
      '裂變係數：平均每次分享帶嚟嘅新客數目',
      '獎勵成本：精準計算每個新客獲取成本'
    ],
    image: 'https://spics.inctrip.com/21b75f33465b5c856666c6757e1fa933.png',
    alt: '餐廳社交分享活動數據儀表板',
    backgroundColor: '#fef8f6'
  }
]

const NUMBERED_CARD_ITEMS: readonly NumberedCardItem[] = [
  {
    title: '設定 MGM 活動',
    description: '喺後台品牌活動管理度建立社交分享活動，設定活動期、獎勵規則同券包，上線後即刻生效。',
    image: 'https://spics.inctrip.com/f7af507710bff81af0c4ed8c08055031.png',
    alt: '設定餐廳 MGM 活動的後台管理圖示'
  },
  {
    title: '顧客分享邀請',
    description: '食客喺餐廳首頁或活動頁見到活動，透過 WhatsApp / 微信分享俾好友，邀請好友一齊享優惠。',
    image: 'https://spics.inctrip.com/f354bb57a6825d4729f58521dc6a444a.png',
    alt: '顧客分享餐廳邀請的社交渠道圖示'
  },
  {
    title: '雙方獲獎 · 餐廳賺客',
    description: '好友註冊拎走新人券包，完成首單後分享人自動收到獎勵，餐廳輕輕鬆鬆贏得新嘅忠實客戶。',
    image: 'https://spics.inctrip.com/ad577f45980a6c9ada762fb1493acf61.png',
    alt: '分享人與受邀人獲獎及餐廳獲客圖示'
  }
]

@Component({
  components: {
    InfoBlock,
    NumberedCardSection,
  },
})
export default class RestaurantSocialMgm extends Vue {
  readonly infoSections: readonly InfoSectionItem[] = INFO_SECTIONS
  readonly numberedCardItems: readonly NumberedCardItem[] = NUMBERED_CARD_ITEMS

  hasImage(image?: string | null): boolean {
    return typeof image === 'string' && image.trim().length > 0
  }
}
